function leaving_site() {

  // ==================================================================== //
  // Leaving Site Script to trigger foundation modal
  // Allows for the notification and download of PDF documents as well
  // ==================================================================== //

  // Get hostname to detect internal links
  var hostname = window.location.hostname;

  // Variable for main content wrapper
  var container = ".page-template";

  // Variable for website name; "You are about to leave the website_name Web Site" message
  var website_name = "Abilities First";

  // Add class ".external" to all anchors that begin with "http://" or "https://" inside site wrapper
  // Force auto open in new window

  jQuery(container + " a[href^='http://']").attr("target","_blank");
  jQuery(container + " a[href^='http://']").addClass("external");
  jQuery(container + " a[href^='https://']").attr("target","_blank");
  jQuery(container + " a[href^='https://']").addClass("external");

  // Add class "internal" if "http://"" starts with the hostname, and prevent opening in new window
  jQuery(container + " a[href^=\'http://"+hostname+"/\']").removeClass("external").removeAttr('target').addClass("internal");
  jQuery(container + " a[href^=\'https://"+hostname+"/\']").removeClass("external").removeAttr('target').addClass("internal");

  // Log all external links with class "external" for debugging
  jQuery( "a.external" ).each(function( index ) {
   // console.log( index + ": Link text: " + jQuery( this ).text());
   // console.log( index + ': Link href: ' + jQuery( this ).attr("href") );
  });

  jQuery(".external").click(function(e){

    // Get href attribute of anchor
    var href = jQuery(this).attr('href');

    // Check if url is a link to a PDF
    var pdf = href.search(".pdf");


    if(pdf > 0) {
      jQuery('#leaving-site .dialog-msg').html("<p>You are about to download&nbsp;a&nbsp;PDF.</p>");
      jQuery('#leaving-site .destination').attr('href',href);
      jQuery('#leaving-site .location').html(href);
      jQuery('#leaving-site').foundation('open');
      return false;
    } else {
      jQuery('#leaving-site .dialog-msg').html("<p class=\"white f3\">You are about to leave<br>the " + website_name + " Web&nbsp;Site.<br><br>Do you wish to proceed?</p>");
      jQuery('#leaving-site .destination').attr('href',href);
      jQuery('#leaving-site .location').html(href);
      jQuery('#leaving-site').foundation('open');
      return false;
  }
});

}

function pdf_link() {

  jQuery('a[href*=".pdf"]').each(function(i){
    var this_link = jQuery(this).attr('href');
    jQuery(this).addClass('pdf');
    jQuery(this).attr('data-pdf',this_link);
    jQuery(this).attr('href','#');
  });
  jQuery('a[data-pdf]').click(function(e){
    var this_link = jQuery(this).attr('data-pdf');
    jQuery('#leaving-site .dialog-msg').html("<p class=\"f4 f3-m f2-l mv3\" style=\"color:white;\">You are about to download&nbsp;a&nbsp;PDF.</p>");
    jQuery('#leaving-site .destination').attr('href',this_link);
    jQuery('#leaving-site .location').html(this_link);
    jQuery('#leaving-site').foundation('open');
    e.preventDefault();
    e.stopPropagation();
  });

  setInterval(function(){
    var reveal_overlay = jQuery('.reveal-overlay').attr('style');
    // console.log(reveal_overlay);
    if(reveal_overlay === 'display: none;') {
      jQuery('#leaving-site .destination').attr('href','#');
    }
  },1);

}